module.exports = __webpack_public_path__ + "static/media/session-expired-image.7002d74f.png";